export default __webpack_public_path__ + "static/media/Full-fledg.9ef45bd1.xlsm";